import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import LoginTwoFactor from '@/components/loginTwoFactor'
import LoginTwoFactorHelp from '@/components/loginTwoFactorHelp'
import Login from '@/components/login'
import SignUp from '@/components/signup'
import ForgotPassword from '@/components/forgotPassword'
import Logout from '@/components/logout'
import Deals from '@/components/deals'
import ContactCard from '@/components/contactCard'
import OrganizationCard from '@/components/organizationCard'
import DealCard from '@/components/dealCard'
import Activities from '@/components/activities'
import Organizations from '@/components/organizations'
import Contacts from '@/components/contacts'
import Products from '@/components/products'
import Reports from '@/components/reports'
import Settings from '@/components/settings'
import activation from '@/components/activation'
import email from '@/components/email'
import Opportunities from '@/components/opportunities'
import renewPassword from '@/components/renewPassword'
import privacyPolicy from '@/components/privacyPolicy.vue'
import Notifications from '@/components/notifications'
import recoveryInprogress from '@/components/recoveryInprogress'
import defaultCurrencyRequired from '@/components/defaultCurrencyRequired'
import emailTemplateEditor from '@/components/emailTemplateEditor'
import wfEmailTemplateEditor from '@/components/wfEmailTemplateEditor'
import wfEmailTemplates from '@/components/wfEmailTemplates'
import emailTemplates from '@/components/emailTemplates'
import calendar from '@/components/calendar'
import cloudApiToken from '@/components/cloudApiToken'
import sip from '@/components/sip'
import Process from '@/components/process'
import testEditor from '@/components/tableEditorTest'
import calendarManagement from '@/components/calendarManagement'
import timeline from '@/components/newsFeed/timeline'
import WhatsApp from '@/components/whatsapp'

const ifAuthenticated = async (to, from) => {
  try {
    const response = await axios.post(`${process.env.API_URL}/checkAuth`, {}, { withCredentials: true })
    if (response && response.data) {
      return true
    }
    return '/login'
  } catch (e) {
    console.log(e)
    return '/login'
  }
}

let router = createRouter({
  history: createWebHistory(),
  scrollBehavior (to, from, savedPosition) {
    if(from.path=='/defaultCurrencyRequired'){
      return { top: 0, left: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'deals',
      component: Deals,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/deals',
      name: 'ddeals',
      component: Deals,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/loginTwoFactor',
      name: 'loginTwoFactor',
      component: LoginTwoFactor
    },
    {
      path: '/loginTwoFactorHelp',
      name: 'loginTwoFactorHelp',
      component: LoginTwoFactorHelp
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
      alias: '/StandardUserActivation'
    },
    {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: ForgotPassword
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/dealCard/:dealId',
      name: 'dealCard',
      component: DealCard,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/activities',
      name: 'activities',
      component: Activities,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/organizations',
      name: 'organizations',
      component: Organizations,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/opportunities',
      name: 'opportunities',
      component: Opportunities,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/contactCard/:contactId',
      name: 'contactCard',
      component: ContactCard,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/organizationCard/:orgId',
      name: 'organizationCard',
      component: OrganizationCard,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/products',
      name: 'products',
      component: Products,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      beforeEnter:ifAuthenticated,
      meta: {
        auth: true // A protected route
      },
    },
    {
      path: '/defaultCurrencyRequired',
      name: 'defaultCurrencyRequired',
      component: defaultCurrencyRequired,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/activation',
      name: 'activation',
      component: activation
    }
    ,
    {
      path: '/email',
      name: 'email',
      component: email,
      props: route => ({ 
        action: route.query.action,
        emailAddress: route.query.emailAddress,
        subject: route.query.subject,
        message: route.query.message,
        attachments: route.query.attachments,
      }),
      beforeEnter:ifAuthenticated

    },
    {
      path: '/renewPassword',
      name: 'renewPassword',
      component: renewPassword
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy
    },{
      path: '/notifications',
      name: 'notifications',
      component: Notifications,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/recoveryInprogress',
      name: 'recoveryInprogress',
      component: recoveryInprogress
    },
    {
      path: '/emailTemplateEditor/:emailTemplateId',
      name: 'emailTemplateEditor',
      component: emailTemplateEditor,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/wfEmailTemplateEditor/:emailTemplateId',
      name: 'wfEmailTemplateEditor',
      component: wfEmailTemplateEditor,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/wfEmailTemplates',
      name: 'wfEmailTemplates',
      component: wfEmailTemplates,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/emailTemplates',
      name: 'emailTemplates',
      component: emailTemplates,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: calendar,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/cloudApiToken',
      name: 'cloudApiToken',
      component: cloudApiToken
    },
    {
      path: '/sip',
      name: 'sip',
      component: sip,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/process',
      name: 'process',
      component: Process,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/testEditor',
      name: 'testEditor',
      component: testEditor,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/calendarManagement',
      name: 'calendarManagement',
      component: calendarManagement,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: timeline,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/whatsapp',
      name: 'whatsapp',
      component: WhatsApp,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'all',
      component: Login
    }
  ]
})

export default router
